export enum IssueTrackerStatus {
  Unresolved = 'Unresolved',
  Resolved = 'Resolved',
  Ignored = 'Ignored',
  CantResolve = 'CantResolve',
}
